import { useState } from "react";
import PropTypes from "prop-types";

import ExperienceIcon from "../../../../assets/svg/ExperienceIcon";
import AboutIcon from "../../../../assets/svg/AboutIcon";
import SkillsIconn from "../../../../assets/svg/SkillsIconn";
import EducationIcon from "../../../../assets/svg/EducationIcon";
import ContactIcon from "../../../../assets/svg/ContactIcon";
import Experience from "../../../ProfilePage/Components/experience/experience";
import Skills from "../../../ProfilePage/Components/Skills";
import Education from "../../../ProfilePage/Components/Education";
import ContactDetails from "../../../ProfilePage/Components/ContactDetails";
import About2 from "../../../ProfilePage/Components/About2";

const tabs = [
  {
    label: "About",
    icon: <AboutIcon />,
  },
  {
    label: "Experience",
    icon: <ExperienceIcon />,
  },
  {
    label: "Skills",
    icon: <SkillsIconn />,
  },
  {
    label: "Education & Certifications",
    icon: <EducationIcon />,
  },
  {
    label: "Contact Details",
    icon: <ContactIcon />,
  },
];

const profileDetailsType = PropTypes.shape({
  candidateId: PropTypes.string,
  candidateDetails: PropTypes.shape({
    _id: PropTypes.string,
    profilePic: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    jobTitle: PropTypes.string,
  }),
});

const RenderBody = ({ activeTab, profileDetails }) => {
  switch (activeTab) {
    case 0:
      return <About2 readOnly profileDetails={profileDetails} />;
    case 1:
      return (
        <Experience
          showProfile={true}
          candidateId={profileDetails?.candidateId}
        />
      );
    case 2:
      return <Skills candidateId={profileDetails?.candidateId} />;
    case 3:
      return <Education candidateId={profileDetails?.candidateId} />;
    case 4:
      return <ContactDetails profileDetails={profileDetails} />;
    default:
      return <div />;
  }
};
RenderBody.propTypes = {
  activeTab: PropTypes.number.isRequired,
  profileDetails: profileDetailsType.isRequired,
};

const ProfileTab = ({ profileDetails }) => {
  const [activeTab, setActiveTab] = useState(0);
  const candidateId = profileDetails?.candidateId || profileDetails?.candidateDetails?._id;
  if (!candidateId) {
    return <p className="p-6 text-sm">Candidate profile is unavailable.</p>;
  }

  return (
    <div className="flex bg-white h-full overflow-hidden w-full shadow-[2px_2px_12px_0px_rgba(180,180,180,0.25)] rounded-lg px-20">
      <div className="flex flex-col flex-1">
        {/* Top container */}
        <div className="flex items-center bg-[#FAFAFA] py-2.5 px-2.5 border border-[#F7F7F7] mb-1 relative">
          {/* Image container */}
          <div className="absolute top-0 flex rounded-full h-40 w-40 bg-[#E1E0E0] items-center justify-center max-md:h-36 max-md:w-36">
            {profileDetails?.candidateDetails?.profilePic ? (
              <img
                src={profileDetails?.candidateDetails?.profilePic}
                alt="Candidate profile"
                className="rounded-full h-40 w-40 object-fill z-10 max-md:h-36 max-md:w-36"
              />
            ) : (
              <span className="font-montserrat text-white font-semibold text-6xl uppercase">
                {profileDetails?.candidateDetails?.firstName?.charAt(0)}
                {profileDetails?.candidateDetails?.lastName?.charAt(0)}
              </span>
            )}
          </div>

          <div className="flex justify-center flex-1 gap-1 pl-20 items-center">
            <div />
            <div className="flex flex-col gap-2.5 my-2 items-center">
              <span className="font-montserrat text-charcoal text-2xl border-b border-primary w-max pb-1 px-4 max-md:text-base">
                {profileDetails?.candidateDetails?.firstName}{" "}
                {profileDetails?.candidateDetails?.lastName}
              </span>
              <span className="font-montserrat text-light-black font-medium text-xs max-[900px]:w-min text-center">
                {profileDetails?.candidateDetails?.jobTitle ||
                  "N/A"}
              </span>
            </div>
          </div>
        </div>

        {/* Main Body Wrapper */}
        <div className="flex flex-col flex-1 overflow-hidden relative">
          <div className="flex items-center ml-28 pl-20 border-b gap-4 xl:pr-10 mt-[0.8rem] justify-between pr-4">
            {tabs?.map((item, index) => {
              return (
                <button
                  key={index}
                  onClick={() => setActiveTab(index)}
                  style={{
                    borderBottom:
                      activeTab === index
                        ? "2px solid #EFBF04"
                        : "2px solid transparent",
                  }}
                  className="flex pb-1 h-full w-9 items-center justify-center lg:w-auto"
                >
                  <div className="lg:hidden">{item?.icon}</div>
                  <span className="font-montserrat text-charcoal font-medium text-xs hidden lg:block">
                    {item?.label}
                  </span>
                </button>
              );
            })}
          </div>
          <div className="flex flex-1 flex-col overflow-y-scroll no-scrollbar pl-24 mt-8 min-h-0">
            <RenderBody
              activeTab={activeTab}
              profileDetails={{ ...profileDetails, candidateId }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
ProfileTab.propTypes = { profileDetails: profileDetailsType };

export default ProfileTab;
